import React from 'react';
import styles from './UploadCoverContent.module.scss';

const UploadCoverContent = () => {
  return (
    <div className={styles.root}>
      <p>Рекомендуемое разрешение 786 x 448</p>
      <p>Максимальный размер 15 Мб</p>
      <p>Формат - JPG или JPEG</p>
    </div>
  );
};

export default UploadCoverContent;
